import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { CompanyForm } from "@/components/register/CompanyForm";
import type { Company } from "@/types/auth";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { setupCompanyRequest } from "@/store/slices/authSlice";

const CompanySetup = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading, error, companySetupComplete } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (companySetupComplete) {
      navigate("/");
    }
  }, [companySetupComplete, navigate]);

  useEffect(() => {
    if (error?.error?.detail?.general) {
      toast({
        variant: "destructive",
        title: "Setup failed",
        description: error.error.detail.general[0],
      });
    }
  }, [error, toast]);

  const handleCompanySubmit = async (data: Company) => {
    dispatch(setupCompanyRequest(data));
    return { success: !error };
  };

  return (
    <div className="container max-w-2xl mx-auto py-10 px-4">
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-8">
        <h1 className="text-2xl font-bold mb-8 text-slate-900">Company Setup</h1>
        <CompanyForm 
          onSubmit={handleCompanySubmit} 
          apiError={error?.error}
        />
      </div>
    </div>
  );
};

export default CompanySetup;